import PlatformIcon from "@/components/icons/platform-icon"
import {
  PlatformStatusCheckMark,
  PlatformStatusXMark,
} from "@/components/icons/platform-status-mark"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import type { Platform } from "@/types"

function CountPlatformIcon({ platform }: { platform: string }) {
  return (
    <PlatformIcon
      platform={platform}
      className="text-muted-foreground size-3.5"
    />
  )
}

export default function PlatformLimitIndicator({
  length,
  metric = "characters",
  platforms,
}: {
  length: number
  metric?: "characters" | "images"
  platforms: Platform[]
}) {
  const limitLabel = metric === "images" ? "images" : "character"

  return (
    <div className="flex items-center gap-3" aria-live="polite">
      {metric === "characters" && (
        <span className="text-muted-foreground text-xs">
          {length} characters
        </span>
      )}
      {platforms.map((platform) => {
        const limit =
          metric === "images" ? platform.image_limit : platform.character_limit
        if (limit == null) return null

        const under = length <= limit
        return (
          <Tooltip key={platform.name}>
            <TooltipTrigger asChild>
              <span className="flex items-center gap-0.5">
                <CountPlatformIcon platform={platform.name} />
                {under ? <PlatformStatusCheckMark /> : <PlatformStatusXMark />}
              </span>
            </TooltipTrigger>
            <TooltipContent sideOffset={6}>
              {platform.label}: {limit} {limitLabel} max
            </TooltipContent>
          </Tooltip>
        )
      })}
    </div>
  )
}
